import { createFileRoute } from '@tanstack/react-router';
import { PersonalSecurityBackupCodesRoute } from './-route-wrappers';

export const Route = createFileRoute('/_authenticated/settings/personal/security/backup_codes')({
  component: PersonalSecurityBackupCodesRoute,
});
